"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@app/util");
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const config_1 = require("@app/const/config");
const { location: { hostname }, } = window;
const { admin } = (0, config_1.getEndpoints)(hostname);
const PlanningDone = ({ positions, ws, calendarMultiSelect, currentPlan, deleteCurrentPlan, setCalendarMultiSelect, openPlanningUI, setModal, closeFn, }) => {
    const [howToResolveUnassigned, setHowToResolveUnassigned] = (0, react_1.useState)(null);
    const optsResolveUnassigned = [
        {
            value: 'replan',
            label: (0, i18n_1.t)('REPLAN_WITH_DIFFERENT_SETTINGS'),
        },
        {
            value: 'offer',
            label: (0, i18n_1.t)('TIMEOFF_CONFLICT_ACTION5'),
        },
    ];
    const isAdmin = document.querySelector('.ds-adminpanel');
    const isLocal = ['localhost', 'app.local.dayswaps.top'].includes(window.location.hostname);
    // parse & join the planner result
    const finalResult = {};
    if (currentPlan?.result) {
        currentPlan?.result.successPerWeight.forEach((spw) => {
            if (spw?.values) {
                Object.keys(spw.values).forEach((k) => {
                    if (isNaN(parseInt(spw.values[k])))
                        return;
                    if (!Object.keys(finalResult).includes(k)) {
                        finalResult[k] = {
                            key: k,
                            sum: 0,
                            count: 0,
                        };
                    }
                    finalResult[k].count += spw.shiftsCount;
                    finalResult[k].sum += parseInt(spw.values[k]) * spw.shiftsCount;
                });
            }
        });
        console.log('=================================');
        Object.keys(finalResult).forEach((k) => {
            finalResult[k].average = finalResult[k].sum / finalResult[k].count;
            console.log('  ', k, ':', finalResult[k].average);
        });
    }
    const tableConfigResults = [
        {
            key: 'resultKey',
            tlKey: '',
            sortable: false,
            filterable: false,
            rowToHTML: (row) => (react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM }, (0, i18n_1.t)('PLANNER_RT.' + row.key))),
            rowToStr: (row) => (0, i18n_1.t)('PLANNER_RT.' + row.key),
        },
        {
            key: 'resultAverage',
            tlKey: (0, i18n_1.t)('RESULT'),
            sortable: false,
            filterable: false,
            rowToHTML: (row) => {
                let weight = ws.settings.plannerDefaults.ruleWeights
                    ? ws.settings.plannerDefaults.ruleWeights[row.key]
                    : 0;
                const override = currentPlan?.planningRuleWeightOverrides.find((o) => o.ruleType === row.key);
                if (override) {
                    weight = override.value;
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD }, util_1.numberUtil.round2decimals(row.average)),
                    ' ',
                    react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM },
                        " / ",
                        weight)));
            },
            rowToStr: (row) => util_1.numberUtil.round2decimals(row.average),
        },
    ];
    const multiselectedShifts = (calendarMultiSelect?.sourceEvents || []).filter((evt) => typeof evt.available === 'undefined' && !evt.categoryId);
    const unassignedShifts = multiselectedShifts.filter((s) => currentPlan?.selectedShifts.includes(s.id) &&
        !currentPlan?.result?.plannedShifts.some((ps) => ps.sourceId === s.id && !!ps.userId));
    (0, react_1.useEffect)(() => {
        // on the 1st mount of this:
        //   - if we have multiselected some other shift than we recently planned, reset to PlanningSetup phase and start there, from the beginning
        //   - if we still have multiselected the same list of shifts that was recently planned, do nothing here, so we can reexamine the results of that recent planning
        const selectedShifts = multiselectedShifts.map((s) => s.id);
        selectedShifts.sort((a, b) => {
            return a < b ? -1 : 1;
        });
        const justPlannedShifts = currentPlan?.selectedShifts;
        justPlannedShifts?.sort((a, b) => {
            return a < b ? -1 : 1;
        });
        const isMultiselectedJustPlannedShifts = util_1.miscUtil.safeStringify(justPlannedShifts) ===
            util_1.miscUtil.safeStringify(selectedShifts);
        if (!isMultiselectedJustPlannedShifts) {
            deleteCurrentPlan();
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'ds-planning-sidebar-planner-header' },
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN, align: _ui_1.Flex.POSITION.CENTER, stretch: true },
                    react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
                        react_1.default.createElement(_ui_1.Text, { weight: _ui_1.Text.WEIGHTS.SEMI_BOLD, type: _ui_1.Text.TYPES.BODY_LARGE }, (0, i18n_1.t)('PLANNING_FINISHED'))),
                    react_1.default.createElement(_ui_1.Icon, { color: _ui_1.Icon.COLORS.INHERIT, ico: _ui_1.Icon.ICONS.close1, size: _ui_1.Icon.SIZES.MEDIUM, onClick: () => {
                            deleteCurrentPlan();
                            closeFn();
                        } })))),
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
                react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE },
                    (0, i18n_1.t)('SHIFTS') + ': ',
                    react_1.default.createElement("b", null, currentPlan?.selectedShifts?.length?.toString())),
                react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE },
                    (0, i18n_1.t)('PLANNING_SEARCHED') + ': ',
                    react_1.default.createElement("b", null, util_1.numberUtil.round2decimals(currentPlan?.result?.solutionsSearched))),
                isAdmin || isLocal ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
                    react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE },
                        react_1.default.createElement(_ui_1.Link, { type: _ui_1.Link.TYPES.A_TAG, to: admin.replace(/\/$/, '') +
                                '/#!/db/plans/' +
                                (currentPlan?.id ?? '') },
                            "Plan: ",
                            currentPlan?.id)))) : null),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_16 }),
            Object.keys(finalResult).length > 0 ? (react_1.default.createElement(_ui_1.Table, { className: 'ds-planning-sidebar-results', tableName: 'planning-results', rows: Object.values(finalResult), showSelection: false, tableConfig: tableConfigResults, pagination: false, showActionBar: false, size: _ui_1.Table.SIZE.SLIM, type: _ui_1.Table.TYPES.LEAN })) : (react_1.default.createElement(_ui_1.Flex, { align: _ui_1.Flex.POSITION.CENTER },
                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.warning, size: _ui_1.Icon.SIZES.MEDIUM }),
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_8 },
                    react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM }, (0, i18n_1.t)('TABLE_NO_DATA')))))),
        unassignedShifts.length > 0 && (react_1.default.createElement("div", { className: 'planning-sidebar-unassigned' },
            react_1.default.createElement(_ui_1.Separator, null),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
                    react_1.default.createElement(_ui_1.Text, null, (0, i18n_1.t)('PLANNING_FINISHED_COULDNT_ASSIGN_X', {
                        x: unassignedShifts.length,
                        y: currentPlan?.selectedShifts?.length,
                    })),
                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
                    react_1.default.createElement("div", { className: 'planning-sidebar-scrollable-list' }, unassignedShifts.map((s) => {
                        const pos = positions.find((p) => p.id === s.positionId);
                        return (react_1.default.createElement("div", { className: 'one-unassigned-shift', key: s.id },
                            react_1.default.createElement(_ui_1.Flex, { align: _ui_1.Flex.POSITION.CENTER },
                                react_1.default.createElement(_ui_1.Position, { size: 'small', pos: pos, lg: false, sm: false, esm: true }),
                                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_8 },
                                    react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM }, (0, moment_1.default)(s.period.start).format('D.M. HH:mm'))))));
                    }))),
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
                react_1.default.createElement(_ui_1.Flex, null,
                    react_1.default.createElement("div", { className: 'planning-sidebar-unassigned-action-dropdown' },
                        react_1.default.createElement(_ui_1.Dropdown, { disableSort: true, label: null, size: _ui_1.Dropdown.SIZES.SMALL, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.OUTLINED, options: optsResolveUnassigned, singleSelect: true, value: optsResolveUnassigned.find((ot) => ot.value === howToResolveUnassigned), onChange: (v) => {
                                setHowToResolveUnassigned(v.value);
                            } })),
                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_4 }),
                    react_1.default.createElement(_ui_1.Button, { onClick: () => {
                            if (howToResolveUnassigned === 'replan') {
                                // multiselect only unplanned shifts & init a new planning
                                setCalendarMultiSelect({
                                    sourceEvents: unassignedShifts.map((evtData) => {
                                        return Object.assign({}, evtData, {
                                            day: (0, moment_1.default)(evtData.period.start).format('YYYY-MM-DD'),
                                        });
                                    }),
                                }).then(async () => {
                                    await deleteCurrentPlan();
                                    if (openPlanningUI)
                                        await openPlanningUI();
                                });
                            }
                            if (howToResolveUnassigned === 'offer') {
                                // multiselect only unplanned shifts & start offers for them
                                setCalendarMultiSelect({
                                    sourceEvents: unassignedShifts.map((evtData) => {
                                        return Object.assign({}, evtData, {
                                            day: (0, moment_1.default)(evtData.period.start).format('YYYY-MM-DD'),
                                        });
                                    }),
                                }).then(() => {
                                    setModal('offers', {
                                        selectedShiftIds: unassignedShifts.map((s) => s.id),
                                        action: 'create',
                                        createType: 'drop',
                                    });
                                    closeFn();
                                });
                            }
                        }, disabled: (0, util_1.isNull)(howToResolveUnassigned), size: _ui_1.Button.SIZES.SMALL, ico: _ui_1.Icon.ICONS.arrowRight, color: _ui_1.Button.COLORS.PRIMARY, style: _ui_1.Button.STYLES.CONTAINED })))))));
};
exports.default = PlanningDone;
